import React from 'react'

const MessageTime: React.FC<{ timestamp: Date }> = ({timestamp}) => {
    const now:any = new Date();
    const timeDifference = now.getTime() - timestamp.getTime();
    const diffInSeconds:any = Math.floor(timeDifference / 1000);
    //const diffInSeconds = Math.floor((now - timestamp) / 1000);
  
    if (diffInSeconds < 5) {
      return <span>Just Now</span>;
    } else if (diffInSeconds < 60) {
      return <span>{`${diffInSeconds} seconds ago`}</span>;
    } else {
      const diffInMinutes = Math.floor(diffInSeconds / 60);
      if (diffInMinutes < 60) {
        return <span>{`${diffInMinutes} minutes ago`}</span>;
      } else {
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) {
          return <span>{`${diffInHours} hours ago`}</span>;
        } else {
          if (
            timestamp.getDate() === now.getDate() - 1 &&
            timestamp.getMonth() === now.getMonth() &&
            timestamp.getFullYear() === now.getFullYear()
          ) {
            return <span>Yesterday</span>;
          } else {
            return <span>{timestamp.toDateString()}</span>;
          }
        }
      }
    }
};

export default MessageTime;

